var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.522 8.783l.899-.946L7.928.957 9.913 2.85 4.3 8.783l5.613 5.934-1.985 1.892L1.42 9.73l-.9-.946z",
    fill: "#085FE5"
  })));
}

export default SvgSidebarClose;